module.exports = __webpack_public_path__ + "static/media/MarkerFelt-Wide.c0df35f7.svg";